import React from 'react';
import { observer } from 'mobx-react';
import { Badge } from 'react-bootstrap';

import { WidgetRow } from 'src/libs/ui-kit/widget-row/WidgetRow';

import { widgetLabels } from '../constants';

import { useProfileWidgetStore } from './StoreProvider';

export const UserTypeRow = observer(() => {
  const { profile } = useProfileWidgetStore();
  return (
    <WidgetRow
      label={widgetLabels.userType}
      value={
        profile?.userType && (
          <Badge as="span" variant="default">
            {profile.userType}
          </Badge>
        )
      }
    />
  );
});
